module.exports = __webpack_public_path__ + "sq6-43fc13b6.png";